import { defineComponent } from "vue";

export default defineComponent({
  setup() {

    // console.log(store.state.logs)
    
  },
});